const popularQuestions = [
  "How do I create an account on Uplus?",
  "How do I reset my password when forgotten?",
  "How do I create a Crowdfunding group?",
  "How do I create Ikimina group?",
  "How do I create goal?",
];

export default popularQuestions;
